var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2285,
    cy: 24.5,
    r: 22.3047,
    stroke: "white",
    strokeWidth: 4.3906
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3353 8.27278C28.7845 8.27278 32.1453 9.36475 34.9358 11.3922C37.7263 13.4196 39.8033 16.2784 40.8692 19.5588C41.9351 22.8393 41.9351 26.373 40.8692 29.6534C39.8033 32.9338 37.7263 35.7926 34.9358 37.8201L25.3353 24.6061L25.3353 8.27278Z",
    fill: "#F2CA88"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeD);
export default __webpack_public_path__ + "static/media/typeD.74710c68fdbca42c2037b7db31a608e5.svg";
export { ForwardRef as ReactComponent };